module.exports = __webpack_public_path__ + "media/images/official/special_workcation_01-da9549c8bde3ec6ce0015419f41d06be.jpg";